import { Phone } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Reveal from "./Reveal";
import { FAQS, SITE } from "@/data/content";

export default function FAQ() {
  return (
    <section id="faqs" className="py-24 lg:py-32 bg-paper" data-testid="faq-section">
      <div className="container-luxe grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <p className="eyebrow mb-4">FAQs</p>
          <h2 className="font-serif font-semibold text-navy text-4xl sm:text-5xl leading-[1.05] tracking-tight">
            Questions, Answered Honestly
          </h2>
          <p className="mt-5 text-body leading-relaxed text-sm">
            Straight answers about Dholera and how we work. For anything specific, just call.
          </p>
          <a href={SITE.phoneHref} data-testid="faq-call-button" className="btn-navy mt-8">
            <Phone className="w-4 h-4" /> {SITE.phoneDisplay}
          </a>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-border" data-testid={`faq-accordion-item-${i}`}>
                <AccordionTrigger className="text-left font-serif text-xl sm:text-2xl text-navy font-semibold py-5 hover:text-gold-dark hover:no-underline transition-colors duration-300">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-body text-sm sm:text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
